import Cookies from 'cookies-js';

Cookies.defaults = {
  path: '/',
  secure: true,
};
